module.exports = __webpack_public_path__ + "static/media/iconMessagesGray.0d4de63f.svg";